import { PATHS } from '@tom-ui/utils'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import InventoryDrone from './InventoryDrone'

export const InventoryDronePage: FC = () => {
  const navigate = useNavigate()
  return <InventoryDrone onClose={() => navigate(PATHS.arcade.url)} />
}
